import React, { useEffect, useState } from 'react';
import styles from './styles';
import { withStyles } from '@material-ui/core';
import CustomerHolds from './Grid/index';
import { getDataWithQueryString } from '../../../../../api/componentAPIs';
import appConstants from '../../../../../appConstants';
import Events from '../../../../../utilities/EventEmitter';
import { compose } from 'recompose';
import { withAppConfig } from '../../../../../appConfigContext';
import { getGridFeatureFlagsByGridNames } from '../../../utils';

const HoldPros = ({ classes, configJSON }) => {
  const [holdData, setHoldData] = useState({});
  const [errorMessage, setErrorMessage] = useState(appConstants.GRID_STATUS.LOADING);
  const enabledTabs =
    getGridFeatureFlagsByGridNames(configJSON.gridConfiguration, 'HoldProGrid')?.tab || {};
  const hasEnabledHoldProTabs = Object.values(enabledTabs).some((value) => Boolean(value));

  const getHoldProData = () => {
    getDataWithQueryString('GetHoldData').then((response) => {
      if (response && response.status >= 200 && response.status < 400) {
        setHoldData(response.data || {});
        setErrorMessage(appConstants.GRID_STATUS.SUCCESS);
      } else {
        setHoldData({});
        setErrorMessage(appConstants.GRID_STATUS.ERROR);
      }
    });
  };

  useEffect(() => {
    getHoldProData();
  }, []);

  const updateHoldData = () => {
    getHoldProData();
    Events.emit('RefreshIBStore');
  };

  return (
    <>
      <header className={classes.moduleHeader} data-automationid="holdPros-title">
        Hold Pros
      </header>
      <div className={classes.moduleContainer}>        
        {hasEnabledHoldProTabs ? (
          <div className={classes.holdProCustomerGrid}>
            <CustomerHolds
              holdData={holdData}
              updateHoldData={updateHoldData}
              errorMessage={errorMessage}
              enabledTabs={enabledTabs}
            />
          </div>
        ) : (
          <div className={classes.errorMessage}>All Hold Pros options are disabled</div>
        )}
      </div>
    </>
  );
};

export default compose(withStyles(styles), withAppConfig)(HoldPros);
